import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';
import { PaletteColor } from '@utils/types';
import OriginalPrice from '@components/ui/price/OriginalPrice';

export const NumericValuesContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RedDivider = styled.div<{
  height?: number;
  width?: number;
}>`
  width: ${({ width = 6 }) => `${width}px`};
  margin-right: 10px;
  height: ${({ height = 36 }) => `${height}px`};
  border-radius: 5px;
  background-color: ${({ theme }) => `${theme.palette.coral}`};
`;

export const PriceContainer = styled.div<{
  displayFlex: boolean;
  discount: boolean;
}>`
  margin-right: auto;
  padding-left: ${(props) => (props.discount ? '15px' : '0')};
  color: ${({ theme }) => `${theme.palette.eclipse}`};
  ${({ displayFlex }) =>
    displayFlex
      ? `
    display:flex;
    align-items:baseline;
  `
      : ``}
`;
export const Discount = styled.div`
  width: 15%;
  font-size: 12px;
  font-weight: 900;
  padding-right: 10px;
  color: ${({ theme }) => `${theme.palette.coral}`};
`;
export const PriceIndicator = styled.div<{ color: PaletteColor }>`
  font-size: 12px;

  color: ${({ theme, color }) => theme.palette[color]};
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: 14px;
  }
`;

export const NavCarPrice = styled(OriginalPrice)<{
  fontsize: number;
  color: PaletteColor;
}>`
  font-size: ${(props) => props.fontsize}px;
  font-weight: 900;
  color: ${({ theme, color }) => theme.palette[color]};
`;

export const DiscountValue = styled.span`
  font-size: 14px;
  display: block;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: 18px;
  }
`;
